import { StoreActionType as Type } from "../../types";

const initialState: any = {};

export const checkOperatorReducer: any = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Type.SET_CHECK_OPERATOR_INFO:
      return {
        ...state,
        ...action?.info,
      };

    default:
      return state;
  }
};
